import { Dialog, DialogProps } from "@mui/material";

import AppModalContent from "@/common/components/Modals/AppModalContent";
import { ViewVariant } from "@/common/ts/layout";

import GeneralHistoryPaginatedList, {
  GeneralHistoryPaginatedListProps,
} from "./GeneralHistoryPaginatedList";

export interface OwnProps {
  viewProps: GeneralHistoryPaginatedListProps;
}

type Props = OwnProps & DialogProps;

export default function GeneralHistoryListModal({ viewProps, ...dialogProps }: Props) {
  return (
    <Dialog fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalContent>
        <GeneralHistoryPaginatedList
          {...viewProps}
          displayProps={{
            viewVariant: ViewVariant.Tab, // TODO: must be Modal
            ...viewProps?.displayProps,
          }}
        />
      </AppModalContent>
    </Dialog>
  );
}
